// Auto-generated from button.json
export default {
  "tagName": "ui-button",
  "content": [
    "icon"
  ],
  "contentAttributes": [
    "icon"
  ],
  "types": [
    "emphasis",
    "toggle",
    "animated"
  ],
  "variations": [
    "attached",
    "basic",
    "type",
    "circular",
    "color",
    "compact",
    "social",
    "positive",
    "warning",
    "negative",
    "info",
    "transparent",
    "floated",
    "fluid",
    "size",
    "inverted"
  ],
  "states": [
    "hover",
    "focused",
    "active",
    "disabled",
    "loading"
  ],
  "settings": [
    "icon-only",
    "icon-after",
    "href"
  ],
  "attributes": [
    "icon",
    "emphasis",
    "toggle",
    "animated",
    "hover",
    "focused",
    "active",
    "disabled",
    "loading",
    "attached",
    "basic",
    "type",
    "circular",
    "color",
    "compact",
    "social",
    "positive",
    "warning",
    "negative",
    "info",
    "transparent",
    "floated",
    "fluid",
    "size",
    "inverted",
    "icon-only",
    "icon-after",
    "href"
  ],
  "optionAttributes": {
    "primary": "emphasis",
    "secondary": "emphasis",
    "horizontal-animated": "animated",
    "vertical-animated": "animated",
    "fade-animated": "animated",
    "disabled": "disabled",
    "clickable-disabled": "disabled",
    "top-attached": "attached",
    "attached": "attached",
    "bottom-attached": "attached",
    "left-attached": "attached",
    "right-attached": "attached",
    "basic": "basic",
    "very-basic": "basic",
    "submit": "type",
    "reset": "type",
    "red": "color",
    "orange": "color",
    "yellow": "color",
    "olive": "color",
    "green": "color",
    "teal": "color",
    "blue": "color",
    "violet": "color",
    "purple": "color",
    "pink": "color",
    "brown": "color",
    "grey": "color",
    "black": "color",
    "compact": "compact",
    "very-compact": "compact",
    "instagram": "social",
    "facebook": "social",
    "twitter": "social",
    "linkedin": "social",
    "youtube": "social",
    "positive": "positive",
    "subtle-positive": "positive",
    "warning": "warning",
    "subtle-warning": "warning",
    "negative": "negative",
    "subtle-negative": "negative",
    "info": "info",
    "subtle-info": "info",
    "left-floated": "floated",
    "right-floated": "floated",
    "mini": "size",
    "tiny": "size",
    "small": "size",
    "medium": "size",
    "large": "size",
    "big": "size",
    "huge": "size",
    "massive": "size"
  },
  "propertyTypes": {
    "icon": "string",
    "emphasis": "string",
    "toggle": "boolean",
    "animated": "string",
    "hover": "boolean",
    "focused": "boolean",
    "active": "boolean",
    "disabled": "string",
    "loading": "boolean",
    "attached": "string",
    "basic": "string",
    "type": "string",
    "circular": "boolean",
    "color": "string",
    "compact": "string",
    "social": "string",
    "positive": "string",
    "warning": "string",
    "negative": "string",
    "info": "string",
    "transparent": "boolean",
    "floated": "string",
    "fluid": "boolean",
    "size": "string",
    "inverted": "boolean",
    "icon-only": "boolean",
    "icon-after": "boolean",
    "href": "string"
  },
  "allowedValues": {
    "emphasis": [
      "primary",
      "secondary"
    ],
    "animated": [
      "horizontal-animated",
      "vertical-animated",
      "fade-animated"
    ],
    "disabled": [
      "disabled",
      "clickable-disabled"
    ],
    "attached": [
      "top-attached",
      "attached",
      "bottom-attached",
      "left-attached",
      "right-attached"
    ],
    "basic": [
      "basic",
      "very-basic"
    ],
    "type": [
      "submit",
      "reset"
    ],
    "color": [
      "red",
      "orange",
      "yellow",
      "olive",
      "green",
      "teal",
      "blue",
      "violet",
      "purple",
      "pink",
      "brown",
      "grey",
      "black"
    ],
    "compact": [
      "compact",
      "very-compact"
    ],
    "social": [
      "instagram",
      "facebook",
      "twitter",
      "linkedin",
      "youtube"
    ],
    "positive": [
      "positive",
      "subtle-positive"
    ],
    "warning": [
      "warning",
      "subtle-warning"
    ],
    "negative": [
      "negative",
      "subtle-negative"
    ],
    "info": [
      "info",
      "subtle-info"
    ],
    "floated": [
      "left-floated",
      "right-floated"
    ],
    "size": [
      "mini",
      "tiny",
      "small",
      "medium",
      "large",
      "big",
      "huge",
      "massive"
    ]
  },
  "attributeClasses": [
    "icon",
    "animated",
    "disabled",
    "attached",
    "social"
  ],
  "defaultValues": {
    "icon-only": false,
    "icon-after": false,
    "href": ""
  },
  "inheritedPluralVariations": [
    "inverted",
    "size",
    "floated",
    "compact",
    "color",
    "attached"
  ]
};
